import React from 'react';

const InfoCallout = ({
  children,
}) => (
  <div className="info-callout">
    <span className="icon"><i className="icon-info"></i></span>
    <span className="text">{children}</span>
  </div>
);

export default InfoCallout;